$(document).ready(function () {
    $('.partner-career-container input[type="submit"]').on('click', function (e) {
        e.preventDefault()

        if ($('#stimme').is(':checked')) {
            window.location.href = $('#stimme').parent().data('route')
        } else {
            $('#stimme').siblings('label').addClass('red-text')
        }
    })
})
